import fetchApi from 'components/utils/fetch_api'

const bankAccountsIndex = params => {
  return fetchApi('recipients/cw/intermediary_routing/bank_accounts', { params })
}

export { bankAccountsIndex }
